export class FileVersion {
    version!: string;
    size!: number;
    md5!: string;
}